export default __webpack_public_path__ + "locales/sk/Settings.json?hash=af515eb685676094673a0e9c17a7227a";